export type CourseStatus = {
  isFinished: boolean;
  hasAlreadyFollowed: boolean;
  isNotStarted: boolean;
  isFollowing: boolean;
};

type CourseLike = {
  userCourseCompletionRate?: number | null;
  userHasFollowedCourse?: boolean;
  userIsFollowingCourse?: boolean;
};

export default function useCourseStatus(course: CourseLike): CourseStatus {
  const progression = course?.userCourseCompletionRate ?? null;
  const hasFollowedCourse = Boolean(course?.userHasFollowedCourse);
  const isFollowingCourse = Boolean(course?.userIsFollowingCourse);

  const isFinished = progression === 100;
  const hasAlreadyFollowed = !isFinished && hasFollowedCourse && !isFollowingCourse;
  const isNotStarted = !isFinished && !hasFollowedCourse && !isFollowingCourse;
  const isFollowing = !isFinished && isFollowingCourse;

  return { isFinished, hasAlreadyFollowed, isNotStarted, isFollowing };
}
